<template>
  <div class="body">
    <!-- <full-page ref="fullpage" :options="options"> -->
    <!-- <div class="nav">
      <div class="menu_nav contain">
        <div class="menu_box">
          <div class="img_box">
            <img src="@/assets/img/logo.png" alt="Logo" class="logo-img" />
          </div>

          <ul class="menu_list">
            <li
              v-for="menuItem in menuItems"
              :key="menuItem.id"
              class="menu_item"
              :class="{ has_submenu: menuItem.submenu, act: iNum == menuItem.id }"
            >
              <p
                @click="toPush(menuItem.url, menuItem.id, 1, menuItem.label)"
                :style="iNum == menuItem.id ? 'color:#4c7ee9;' : ''"
            
              >
                {{ menuItem.label }}
              </p>
              <div v-if="menuItem.submenu" class="sub_menu_box">
                <ul class="sub_menu_list">
                  <li
                    v-for="subMenuItem in menuItem.submenu"
                    :key="subMenuItem.id"
                    class="sub_menu_item"
                    @click="
                      toPush(
                        subMenuItem.url,
                        subMenuItem.id,
                        0,
                        subMenuItem.label,
                        menuItem.id
                      )
                    "
                  >
                    <p :style="iNums == subMenuItem.id ? 'color:#4c7ee9' : ''">
                      {{ subMenuItem.label }}
                    </p>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
    <!-- <div :class="language == 'zh-CN' ? 'nav' : 'nav_en'"> -->
      <div class="nav ">
  <nav class="navbar navbar-expand-lg navbar-light contain menu_nav ">

    <a class="navbar-brand" href="#">
      <img
        src="@/assets/img/logo.png"
        alt="Logo"
        class="logo-img"
        style="height: 35px"
      />
    </a>

  
   

    <!-- <div class="actionch d-none d-lg-block">
      <div class="H-lang" @click="showLanguageBox = !showLanguageBox">
        <img src="./assets/img/newhome/language.png" alt="语言选择" />
      </div>
      <div class="Hlang-box" v-show="showLanguageBox" @click.stop>
        <a href="javascript:;" class="CN" @click="changeLanguage('zh-CN')">中文</a>
        <a href="javascript:;" class="CN" @click="changeLanguage('zh-EN')">English</a>
      </div>
    </div> -->
      <!-- 导航菜单 -->
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul v-if="language == 'zh-CN'" class="navbar-nav mr-auto menu_list">
        <li
          v-for="menuItem in menuItems"
          :key="menuItem.id"
          class="nav-item dropdown"
        >
          <a
            class="nav-link"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-expanded="false"
            :class="{
              active: iNum == menuItem.id,
              'dropdown-toggle': menuItem.submenu && menuItem.submenu.length > 0,
            }"
            :style="iNum == menuItem.id ? 'color:#4c7ee9;' : ''"
            @click.prevent="toPush(menuItem.url, menuItem.id, 1, menuItem.label)"
          >
            {{ menuItem.label }}
          </a>
          <div
            class="dropdown-menu"
            v-if="menuItem.submenu && menuItem.submenu.length > 0"
          >
            <a
              class="dropdown-item"
              v-for="subMenuItem in menuItem.submenu"
              :key="subMenuItem.id"
              href="#"
              :style="iNums == subMenuItem.id ? 'color:#4c7ee9' : ''"
              @click.prevent="
                toPush(subMenuItem.url, subMenuItem.id, 0, subMenuItem.label, menuItem.id)
              "
            >
              {{ subMenuItem.label }}
            </a>
          </div>
        </li>
      </ul>
      <ul v-if="language == 'zh-EN'" class="navbar-nav mr-auto menu_list">
        <li
          v-for="menuItem in menuItemInternation"
          :key="menuItem.id"
          class="nav-item dropdown"
        >
          <a
            class="nav-link"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-expanded="false"
            :class="{
              active: iNum == menuItem.id,
              'dropdown-toggle': menuItem.submenu && menuItem.submenu.length > 0,
            }"
            :style="iNum == menuItem.id ? 'color:#4c7ee9;' : ''"
            @click.prevent="toPush(menuItem.url, menuItem.id, 1, menuItem.label)"
          >
            {{ menuItem.label }}
          </a>
          <div
            class="dropdown-menu"
            v-if="menuItem.submenu && menuItem.submenu.length > 0"
          >
            <a
              class="dropdown-item"
              v-for="subMenuItem in menuItem.submenu"
              :key="subMenuItem.id"
              href="#"
              :style="iNums == subMenuItem.id ? 'color:#4c7ee9' : ''"
              @click.prevent="
                toPush(subMenuItem.url, subMenuItem.id, 0, subMenuItem.label, menuItem.id)
              "
            >
              {{ subMenuItem.label }}
            </a>
          </div>
        </li>
      </ul>
    </div>
    <div class="mobile-actions ">
      <!-- 语言选择框1 -->
      <div class="actionch">
        <div class="H-lang" @click="showLanguageBox = !showLanguageBox">
          <img src="./assets/img/newhome/language.png" alt="语言选择" />
        </div>
        <div class="Hlang-box" v-show="showLanguageBox" @click.stop>
          <a href="javascript:;" :class="['CN', language == 'zh-CN' ? 'actcn' : '']" @click="changeLanguage('zh-CN')">中文</a>
          <a href="javascript:;" :class="['CN', language == 'zh-EN' ? 'actcn' : '']" @click="changeLanguage('zh-EN')">English</a>
        </div>
      </div>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
  </nav>
</div>
    <!-- {{$route.meta.keepAlive}} -->
 <!-- 中英文网站切换 -->
 <!-- <div class="language-switch" v-show="showLanguageBox" >
          <el-select v-model="language" @change="changeLanguage" placeholder="">
            <el-option label="中文" value="zh-CN" />
            <el-option label="English" value="zh-EN" />
          </el-select>
        </div> -->
    <el-config-provider :locale="zhCN">
      <!-- <KeepAlive>
             <router-view  :searchKeyword="searchKeyword"/>
           </KeepAlive> -->
      <!-- <router-view v-slot="{ Component }" :searchKeyword="searchKeyword">
            <keep-alive>
              <component :is="Component" /> 
            </keep-alive>
          </router-view> -->
      <!-- <router-view v-slot="{ Component }" :searchKeyword="searchKeyword" v-if="!$route.meta.keepAlive">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view> -->

      <router-view :searchKeyword="searchKeyword" />
    </el-config-provider>

    <div class="foot" v-if="language == 'zh-CN'">
      <div class="contain">
        <div class="foot_top">
          <ul>
            <li>
              <img src="@/assets/img/home/1.png" alt="" />
              <p>专精特新中小企业</p>
            </li>
            <li>
              <img src="@/assets/img/home/2.png" alt="" />
              <p>高新技术企业</p>
            </li>
            <li>
              <img src="@/assets/img/home/3.png" alt="" />
              <p>ISO900认证</p>
            </li>
            <li>
              <img src="@/assets/img/home/4.png" alt="" />
              <p>ISO14000认证</p>
            </li>
            <li>
              <img src="@/assets/img/home/5.png" alt="" />
              <p>ISO14500认证</p>
            </li>
            <li>
              <img src="@/assets/img/home/6.png" alt="" />
              <p>ISO27000认证</p>
            </li>
            <li>
              <img src="@/assets/img/home/7.png" alt="" />
              <p>企业信用等级证</p>
            </li>
          </ul>
        </div>
        <div class="foot_center">
          <div class="f_c_left">
            <p class="title">联系我们</p>
            <p>联系电话：400-888-6283</p>
            <p>
              广州总部地址：广州市天河区黄埔大道西100号之二富力盈泰503-504房
            </p>
            <p>上海分公司地址：上海市松江区蒲汇路178弄2号九亭U天地506室</p>
            <p>中山分公司地址：中山市东区中山六路3号庆丰德远大厦6层604房</p>
            <p>
              深圳分公司地址：深圳市宝安区西乡街道固兴社区新屋园一巷7号万联大厦第9楼第905
            </p>
            <p>
              北京分公司地址：北京市朝阳区建外街道西大望路甲3号蓝堡国际中心1座2207A
            </p>
          </div>
          <div class="f_c_left">
            <p
              style="cursor: pointer"
              class="title"
              @click.prevent="toPush('/', 999, 1, '首页')"
            >
              首页
            </p>
            <p
              style="cursor: pointer"
              v-for="item in listItems.filter(
                (item) => item.typeName !== '产品中心'
              )"
              :key="item.id"
              @click.prevent="
                toPush(item.channelType, item.ID, 1, item.typeName)
              "
            >
              {{ item.typeName }}
            </p>
          </div>
          <div class="f_c_left">
            <p
              style="cursor: pointer"
              class="title"
              v-for="item in listItems.filter(
                (item) => item.typeName == '产品中心'
              )"
              :key="item.id"
            >
              {{ item.typeName }}
            </p>
            <p
              style="cursor: pointer"
              v-for="item in listItems.filter(
                (item) => item.typeName == '产品中心'
              )[0].children"
              :key="item.id"
              @click.prevent="
                toPush(
                  item.channelType,
                  item.ID,
                  0,
                  item.typeName,
                  listItems.filter((item) => item.typeName == '产品中心')[0].ID
                )
              "
            >
              {{ item.typeName }}
            </p>
          </div>
        </div>
        <div class="foot_right" style="margin-top: 10px">
          <p class="text">
            Copyright © 2014-2021 广州快加易计算机科技有限公司 版权所有
          </p>
          <div class="beian">
            <img src="@/assets/img/home/beian.png" alt="" />
            <p class="text" @click="golink">粤ICP备19008717号 | 粤公网安备44010602010358号</p>
          </div>
        </div>
      </div>
    </div>
    <div class="foot_en" v-if="language == 'zh-EN'">
    <div class="contain">
      <div class="footer-columns">
        <div class="column">
          <h3>Product Center</h3>
          <p
              style="cursor: pointer"
              v-for="subItem in menuItemInternation.find(
                (item) => item.label === 'ProductCenter'
              ).submenu"
              :key="subItem.id"
              @click.prevent="
                toPush(subItem.url, subItem.id, 0, subItem.label, 2)
              "
            >
              {{ subItem.label }}
            </p>
        </div>

        <div class="column">
          <h3>Support</h3>
          <p>FAQ</p>
          <p>Service Agreement</p>
          <p>Privacy Policy</p>
        </div>

        <div class="column">
          <h3>About Us</h3>
          <!-- <p
            v-for="subItem in menuItemInternation.find(item => item.label == 'About Us')"
            :key="subItem.id"
            @click.prevent="toPush(subItem.url, subItem.id, 0, subItem.label, 2)"
            style="cursor: pointer"
          >
            {{ subItem.label }}
          </p> -->
        </div>

        <div class="column">
          <h3>Telephone Number</h3>
          <p>Tel: 400-888-6283</p>
        </div>
      </div>
    </div>
  </div>

    <!-- </full-page> -->
  </div>
</template>
<!-- <script>
      // 检测移动端
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      // 去掉某些script文件的引入
      if (isMobile) {
          const scripts = document.querySelectorAll('script');
          scripts.forEach(script => {
              if (script.src.includes('/canyou/js/wza.min.js')) {
                  script.remove();
              }else if(script.src.includes('/canyou/js/wzatool-mp.js')){
                script.remove();
              }
          });
      }
  </script> -->
<script setup>
import { useRouter, useRoute } from "vue-router";
import zhCN from "element-plus/dist/locale/zh-cn.mjs";
// import keep-alive from 'vue-keep-alive'
import { treeList } from "@/api/contPublic";

// import config from "@/core/config";
import { cmsSysconfig } from "@/api/contPublic";
// const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
import { watch } from "vue";
// 导入必要的钩子
import { onMounted, onUnmounted, ref } from "vue";

// 用于获取菜单元素的ref（如果需要）
// const navbarCollapse = ref(null);
const golink = () => {
  window.open('https://beian.miit.gov.cn','_blank')
}
// 处理点击外部区域收起菜单
const handleClickOutside = (e) => {
  // 获取菜单元素和触发按钮
  const collapseElement = document.getElementById('navbarSupportedContent');
  const togglerElement = document.querySelector('.navbar-toggler');
  
  // 判断是否点击了菜单外部且菜单处于展开状态
  if (
    collapseElement && 
    togglerElement && 
    !collapseElement.contains(e.target) && 
    !togglerElement.contains(e.target) && 
    collapseElement.classList.contains('show')
  ) {
    // 收起菜单（使用Bootstrap的API或直接操作类名）
    collapseElement.classList.remove('show');
  }
};

// 挂载时添加事件监听
onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

// 卸载时移除事件监听，避免内存泄漏
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
onMounted(() => {
  // 从localStorage读取保存的语言状态
  const savedLang = localStorage.getItem("preferredLang");
  if (savedLang) {
    language.value = savedLang;
    // 同步路由（避免刷新后路由未更新）
    if (savedLang === "zh-EN") {
      router.push({ name: "homeIntarnal" });
    } else {
      router.push({ name: "home" });
    }
    iNum.value = savedLang === "zh-EN" ? 1 : 999;
    window.sessionStorage.setItem("iNum", iNum.value);
  }else {
    // 无缓存时，根据当前路由设置语言
    if (route.name === 'homeIntarnal') {
      language.value = 'zh-EN';
      localStorage.setItem('preferredLang', 'zh-EN');
    } else {
      language.value = 'zh-CN';
      localStorage.setItem('preferredLang', 'zh-CN');
    }
  }
  document.addEventListener('click', closeLanguageBox);
});
// 卸载时移除监听
onUnmounted(() => {
  document.removeEventListener('click', closeLanguageBox);
});
const route = useRoute();
watch(
  () => route.name,
  () => {
    initas();
  }
);
watch(
  () => route.params.ids,
  () => {
    if (route.path.includes("newsDataViewAfter")) {
      window.sessionStorage.setItem("iNum", 0);
      window.sessionStorage.setItem("iNums", 0);
      initas();
    }
  }
);
const showLanguageBox = ref(false);
// 点击页面其他区域关闭语言框
const closeLanguageBox = (e) => {
  if (!document.querySelector('.H-lang').contains(e.target)) {
    showLanguageBox.value = false;
  }
}
// const options = ref({
//   licenseKey: "YOUR_KEY_HERE",
//   scrollOverflow: true,
//     scrolloverflowmacstyle: false,
// });
const router = useRouter();
const name = ref("");
// const keyName=ref('')
const iNum = ref(0);
const iNums = ref(0);
// const footName = ref({});
// const flinkDate = ref([]);
const inita = async () => {
  iNum.value = window.sessionStorage.getItem("iNum") || 999;
  iNums.value = window.sessionStorage.getItem("iNums") || 0;
  // const res = await getSysConfigByVarName({ varname: ["cfg_webname",'cfg_postal','cfg_address','cfg_phone','cfg_copyright','cfg_security','cfg_record'] });
  const res = await cmsSysconfig({ varname: "cfg_webname" });
  name.value = res.data.data.value;
  document.title = name.value;
};
inita();

const initas = async () => {
  iNum.value = window.sessionStorage.getItem("iNum") || 0;
  iNums.value = window.sessionStorage.getItem("iNums") || 0;
};
const searchKeyword = ref("");
const listItems = ref([]);
const init = async () => {
  const res = await treeList({
    page: 1,
    pageSize: 999,
    isHidden: 0,
  });
  if (res.data.code == 0) {
    listItems.value = res.data.data;

    const list = res.data.data;
    menuItems.value = [{ id: 999, label: "首页", url: "home" }];
    list.forEach((item) => {
      if (!item.children) {
        menuItems.value.push({
          id: item.ID,
          label: item.typeName,
          url: item.channelType,
        });
      } else {
        const submenu = [];
        item.children.forEach((items) => {
          submenu.push({
            id: items.ID,
            label: items.typeName,
            url: items.channelType,
          });
        });
        menuItems.value.push({
          id: item.ID,
          label: item.typeName,
          url: item.channelType,
          submenu: submenu,
        });
      }
    });
    console.log(menuItems.value);
  }
};
init();
const menuItemInternation = ref([
  {
    id: 1,
    label: "Home",
    url: "homeIntarnal", // 匹配国际首页路由路径
    submenu: [],
  },
  {
    id: 2,
    label: "ProductCenter",
    url: "productCenter",
    submenu: [
      { id: 3, label: "DomesticSMS", url: "domesticSMS" },
      { id: 4, label: "InternationalSMS", url: "internationalSMS" },
    ],
  },
  {
    id: 5,
    label: "About Us",
    url: "internationalAbout",
    submenu: [],
  },
  {
    id: 6,
    label: "Trust Center",
    url: "internationalTrust",
    submenu: [],
  },
]);
// const submitSearch = () => {
//   // 处理搜索逻辑，你可以在这里添加相关的处理代码
//   // console.log("搜索关键字:", searchKeyword.value);
//   // 例如，使用路由进行页面跳转
//   searchKeyword.value=keyName.value
//   router.push({ name: "news", params: { id:63,title: '公益资讯' } });
// };
//中英文切换
const language = ref("zh-CN");
const changeLanguage = (lang) => {
  language.value = lang;
  // 新增：将语言状态保存到localStorage
  localStorage.setItem("preferredLang", lang);
  // 根据语言切换路由
  if (lang === "zh-EN") {
    router.push({ name: "homeIntarnal" });
  } else {
    router.push({ name: "home" });
  }
  iNum.value = lang === "zh-EN" ? 1 : 999;
  iNums.value = 0;
  window.sessionStorage.setItem("iNum", iNum.value);
};
const menuItems = ref([]);

const toPush = (url, id, i, title, ids) => {
  // console.log(url, id, i, title);
  window.scrollTo({
    top: 0,
    behavior: "smooth", // 平滑滚动
  });
  // 如果是中文，则跳转到中文页面，否则跳转到英文页面
  if (language.value === "zh-CN") {
    if (i == 1) {
      iNum.value = id;
      window.sessionStorage.setItem("iNum", iNum.value);
      menuItems.value.forEach((item) => {
        if (item.id == id) {
          if (item.submenu && item.submenu.length > 0) {
            // router.push({
            //   name: item.submenu[0].url,
            //   params: { id: item.submenu[0].id, title: item.submenu[0].label },
            // });
            // iNums.value = item.submenu[0].id;
            // window.sessionStorage.setItem("iNums", iNums.value);
          } else {
            window.sessionStorage.setItem("iNums", 0);
            if (url == "/") {
              router.push({ path: url });
            } else {
              router.push({ name: url, params: { id, title } });
            }
          }
        }
      });
      // window.location.reload()
    } else {
      router.push({ name: url, params: { id, title } });
      // window.location.reload()
      iNum.value = ids;
      iNums.value = id;
      // console.log(iNum.value);

      window.sessionStorage.setItem("iNum", iNum.value);
      window.sessionStorage.setItem("iNums", iNums.value);
    }
  } else {
    if (i == 1) {
      iNum.value = id;
      window.sessionStorage.setItem("iNum", iNum.value);
      menuItemInternation.value.forEach((item) => {
        if (item.id == id) {
          if (item.submenu && item.submenu.length > 0) {
            // router.push({
            //   name: item.submenu[0].url,
            //   params: { id: item.submenu[0].id, title: item.submenu[0].label },
            // });
            // iNums.value = item.submenu[0].id;
            // window.sessionStorage.setItem("iNums", iNums.value);
          } else {
            window.sessionStorage.setItem("iNums", 0);
            if (url == "/") {
              router.push({ path: url });
            } else {
              router.push({ name: url, params: { id, title } });
            }
          }
        }
      });
      // window.location.reload()
    } else {
      router.push({ name: url, params: { id, title } });
      // window.location.reload()
      iNum.value = ids;
      iNums.value = id;
      // console.log(iNum.value);

      window.sessionStorage.setItem("iNum", iNum.value);
      window.sessionStorage.setItem("iNums", iNums.value);
    }
  }
  iNum.value = window.sessionStorage.getItem("iNum") || 0;
  iNums.value = window.sessionStorage.getItem("iNums") || 0;
};

// 新增：监听路由name变化，同步语言状态
watch(
  () => route.name,
  (newName) => {
    if (newName === 'homeIntarnal') {
      language.value = 'zh-EN';
      localStorage.setItem('preferredLang', 'zh-EN');
    } else if (newName === 'home') {
      language.value = 'zh-CN';
      localStorage.setItem('preferredLang', 'zh-CN');
    }
    initas(); // 保持原有逻辑
  }
);

</script>
<style lang="scss">
// html{
//   background: #f2f2f2;
// }
ul {
  list-style: none; /* 去除项目符号 */
  padding: 0; /* 重置默认内边距 */
  margin: 0; /* 重置默认外边距 */
}
.contain {
  width: 1200px;
  // width: 80%;
  // max-width: 80%;
  margin: 0 auto;
  box-sizing: border-box;
}
.collapse {
  display: block; /* Override Bootstrap's default behavior */
  visibility: visible !important; /* Ensure visibility */
}
.nav {
  background-color: #fff;
  display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    .navbar-nav {
    display: flex;
    flex-wrap: nowrap; /* 允许换行（小屏幕适配） */
    justify-content: space-around; /* 均匀分布菜单项 */
    width: 100%; /* 占满容器宽度 */
  }

 .navbar-light .navbar-nav .nav-link {
    font-family: PingFang-SC, PingFang-SC !important;
font-weight: 800 !important;
font-size: 14px !important;
color: #182204 !important;
line-height: 20px !important;
text-align: center !important;
font-style: normal !important ;
}

  .navbar-light .navbar-nav .nav-link.active {
    color: rgb(76, 126, 233) !important;
  }
  .navbar-title {
    display: flex;
    align-items: center;
  }

  .navbar-title h1 {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
  }
  .mobile-actions {
    // position: fixed;
    right: 0px;
    z-index: 1;
  }
  .language-switch {
    width: 100px;
    ::v-deep(.el-input__wrapper) {
      border: none !important; /* 去除默认边框 */
      padding: 0; /* 可选：调整内边距避免内容偏移 */
      background: transparent; /* 可选：设置背景透明 */
    }
    :deep(.el-input__wrapper.is-focus) {
      box-shadow: none !important; /* 去除聚焦时的阴影 */
    }
  }
  .sub_menu_box {
    display: none;
  }

  .nav-item.dropdown:hover .sub_menu_box,
  .nav-item.dropdown .sub_menu_box.show {
    // rgb(245, 245, 245)rgb(47, 11, 247)
    display: block;
  }
  .menu_list li,
  .sub_menu_list li,
  .navbar-nav li,
  .dropdown-menu li {
    list-style-type: none;
    margin: 0;
    padding: 0 25px;
    // position: relative;
  }
}
.nav_en {
  background-color: #fff;
  display: flex;
  .navbar-nav {
    display: flex;
    flex-wrap: wrap; /* 允许换行（小屏幕适配） */
    justify-content: space-around; /* 均匀分布菜单项 */
    width: 100%; /* 占满容器宽度 */
  ::v-deep(.navbar-light .navbar-nav .nav-link) {
    font-family: PingFang-SC, PingFang-SC !important;
font-weight: 800 !important;
font-size: 14px !important;
color: #182204 !important;
line-height: 20px !important;
text-align: center !important;
font-style: normal !important ;
  }
}

  .navbar-light .navbar-nav .nav-link.active {
    color: rgb(76, 126, 233) !important;
  }
  .navbar-title {
    display: flex;
    align-items: center;
  }

  .navbar-title h1 {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
  }
  .language-switch {
    width: 100px;
    ::v-deep(.el-input__wrapper) {
      border: none !important; /* 去除默认边框 */
      padding: 0; /* 可选：调整内边距避免内容偏移 */
      background: transparent; /* 可选：设置背景透明 */
    }
    :deep(.el-input__wrapper.is-focus) {
      box-shadow: none !important; /* 去除聚焦时的阴影 */
    }
  }
  .sub_menu_box {
    display: none;
  }

  .nav-item.dropdown:hover .sub_menu_box,
  .nav-item.dropdown .sub_menu_box.show {
    // rgb(245, 245, 245)rgb(47, 11, 247)
    display: block;
  }
  .menu_list li,
  .sub_menu_list li,
  .navbar-nav li,
  .dropdown-menu li {
    list-style-type: none;
    margin: 0;
    padding: 0;
    // position: relative;
  }
}
.actionch{
  padding: 15px;
  position: relative;
}
.Hlang-box {
  z-index: 99;
  position: absolute;
  top: 50px;
  right: 0;
  width: 100px;
  background-color: #fff;
  border: 1px solid #ccc;
  text-align: center;
  .actcn{
    display: block;
    padding: 5px;
    text-decoration: none;
    color: #1176d4;
    background-color: #ccc;
  }
  .CN {
    display: block;
    padding: 5px;
    text-decoration: none;
    color: #333;
    &:hover {
    background-color: rgb(0 0 0 / 16%);
    color: #4c7ee9;
    }
  }
  
}
.foot {
  background: #2c445c;
  padding: 20px 0;
  color: #fff;
  .foot_top {
    width: 100%;
    & > ul {
      display: flex;
      justify-content: space-between;
      & > li {
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 12px;
        & > img {
          margin-right: 5px;
        }
      }
    }
  }
  .foot_center {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    .f_c_left {
      display: flex;
      flex-direction: column;
      color: #d7d8d9;
      font-size: 12px;
      &:nth-child(2) {
        margin-left: -60px;
      }
      & > .title {
        margin-bottom: 10px;
        font-size: 18px;
      }
      & > p {
        margin-bottom: 10px;
      }
    }
  }
  .foot_right {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #d7d8d9;
    .beian {
      margin-top: 10px;
      display: flex;
      align-items: center;
      & > img {
        width: 18px;
        height: 20px;
        margin-right: 5px;
      }
    }
  }
}
.foot_en {
  background: #37383E;
  padding: 20px 0;
  color: #fff;
.footer-columns {
  display: flex;
  justify-content: space-between; /* 均匀分布四列 */
  flex-wrap: wrap; /* 适配小屏幕 */
}

.column {
  flex: 0 0 23%; /* 每列占23%（留出间距） */
  margin-bottom: 20px;
}

.column h3 {
  margin: 35px auto;
  font-family: PingFang-SC, PingFang-SC;
font-weight: 800;
font-size: 16px;
color: #FFFFFF;
line-height: 22px;
text-align: left;
font-style: normal;
}

.column p {
  font-family: PingFang-SC, PingFang-SC;
  font-weight: 800;
  font-size: 14px;
  color: #fff;
  line-height: 20px;
  text-align: left;
  margin: 14px 0;
  cursor: pointer;
  transition: color 0.2s;
}

.column p:hover {
  color: #ccc; /*  hover 效果 */
}
}
:deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 1px #fff !important;
}
// .el-select-dropdown__item.selected {
//   color: #fff !important;
// }
:deep(.el-select-dropdown__item.hover, .el-select-dropdown__item:hover) {
  background-color: #fff;
}
:deep(.is-active) {
  background-color: #fff !important;
}
:deep(.el-select .el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 1px #fff inset !important;
}

:deep(.el-select .el-input.is-focus .el-input__wrapper) {
  box-shadow: 0 0 0 1px #fff !important;
}
:deep(.el-pager li:hover) {
  color: #fff !important;
}

:deep(.el-pager li.is-active:hover) {
  color: #fff !important;
}

:deep(.el-pagination button:hover) {
  color: #fff !important;
}
.body {
  margin-bottom: 200px;
}
.foot {
  width: 100%;
  min-width: 1200px;
  height: 450px;
  .youlian {
    display: flex;
    padding-top: 10px;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-wrap: wrap;
    & > div {
      margin-bottom: 4px;
    }
    li {
      // border: 1px solid #fff;
      color: #fff;
      font-size: 14px;
      line-height: 26px;
      margin-right: 4px;
      margin-bottom: 4px;
      // border-radius: 2px;
      &:last-child > a::after {
        display: none;
      }
      & > a {
        padding: 0 10px;
        position: relative;
        color: #fff;
        &::after {
          content: "";
          display: block;
          position: absolute;
          right: 0;
          height: 100%;
          background-color: #fff;
          width: 1px;
          top: 0;
        }
      }
    }
  }
  .foot_text,
  .foot_address,
  .foot_bootom {
    padding-top: 15px;
    font-size: 16px;
    color: #fff;
    line-height: 38px;
    text-align: center;
  }
  .foot_address {
    padding-top: 0;
  }
  .foot_bootom {
    text-align: center;
  }
}
// .menu_list li:hover,
// .sub_menu_list li:hover,
// .navbar-nav li:hover,
// .dropdown-menu li,
// .nav-link .active::after {
//   // background-color: #f5f5f5;
//   position: absolute;
//   content: "";
//     display: block;
//     width: 30px;
//     height: 3px;
//     bottom: 0;
//     left: 50%;
//     margin-left: -15px;
//     background-color: #4c7ee9;

// }


:deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 1px #fff !important;
}
// .el-select-dropdown__item.selected {
//   color: #fff !important;
// }
:deep(.el-select-dropdown__item.hover, .el-select-dropdown__item:hover) {
  background-color: #fff;
}
:deep(.is-active) {
  background-color: #fff !important;
}
:deep(.el-select .el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 1px #fff inset !important;
}

:deep(.el-select .el-input.is-focus .el-input__wrapper) {
  box-shadow: 0 0 0 1px #fff !important;
}
:deep(.el-pager li:hover) {
  color: #fff !important;
}

:deep(.el-pager li.is-active:hover) {
  color: #fff !important;
}

:deep(.el-pagination button:hover) {
  color: #fff !important;
}
.body {
  margin-bottom: 200px;
}
.foot {
  width: 100%;
  min-width: 1200px;
  height: 450px;
  .youlian {
    display: flex;
    padding-top: 10px;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-wrap: wrap;
    & > div {
      margin-bottom: 4px;
    }
    li {
      // border: 1px solid #fff;
      color: #fff;
      font-size: 14px;
      line-height: 26px;
      margin-right: 4px;
      margin-bottom: 4px;
      // border-radius: 2px;
      &:last-child > a::after {
        display: none;
      }
      & > a {
        padding: 0 10px;
        position: relative;
        color: #fff;
        &::after {
          content: "";
          display: block;
          position: absolute;
          right: 0;
          height: 100%;
          background-color: #fff;
          width: 1px;
          top: 0;
        }
      }
    }
  }
  .foot_text,
  .foot_address,
  .foot_bootom {
    padding-top: 15px;
    font-size: 16px;
    color: #fff;
    line-height: 38px;
    text-align: center;
  }
  .foot_address {
    padding-top: 0;
  }
  .foot_bootom {
    text-align: center;
  }
}
@import "./assets/css/base.css";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

@import "normalize.css";
.el-pagination {
  justify-content: center;
}
.body {
  margin: 0px;
  padding: 0;
}

.header {
  /* 设置背景颜色 */
  width: 100%;
  min-width: 1200px;
}



.header-inner {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.logo-box {
  margin-right: 20px;
}

.h-search-ctl {
  width: 200px;
  margin-right: 5px;
  border-radius: 50% !important;
}

.main-box {
  width: 410px;
  height: 42px;
  display: flex;
  align-items: center;
}

.user-link {
  margin-right: 10px;
  color: #fff;
  /* 设置链接颜色 */
  text-decoration: none;
  /* 去除下划线 */
  font-weight: bold;
  /* 加粗文字 */
  transition: color 0.3s ease;
  /* 添加颜色变化的过渡效果 */

  &:hover {
    color: #4c7ee9;
    /* 设置鼠标悬停时的颜色 */
  }
}
/* 针对小屏幕的手风琴菜单高度自适应调整 */
@media screen and (max-width: 992px) {
  /* 导航栏基础样式保持固定 */
  .nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1050;
    height: 60px;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  /* 内容区域顶部间距 */
  .body > .el-config-provider {
    margin-top: 60px;
  }

  /* 固定logo和汉堡按钮 */
  .navbar-brand, .mobile-actions {
    position: relative;
    z-index: 1051;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 15px;
  }

  /* 手风琴菜单容器 - 高度根据内容自动延伸 */
  .navbar-collapse {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    background-color: white;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    z-index: 1050;
    padding: 20px 15px;
    /* 关键调整：移除固定高度，改为最大高度限制为屏幕剩余空间 */
    max-height: calc(100vh - 60px); /* 最大不超过屏幕可视区域 */
    height: auto; /* 高度随内容自动变化 */
    overflow-y: auto; /* 内容超出最大高度时可滚动 */
  }

  .navbar-collapse.show {
    transform: translateX(0);
    background-color: #fff; /* 背景色 */
  }

  /* 子菜单高度完全自适应内容 */
  .dropdown-menu {
    position: static;
    width: 100%;
    border: none;
    box-shadow: none;
    padding-left: 15px;
    max-height: 0; /* 初始折叠状态 */
    overflow: hidden;
    transition: max-height 0.4s ease;
  }

  /* 子菜单展开时高度自适应内容（使用足够大的值确保内容完全显示） */
  .dropdown.show .dropdown-menu {
    max-height: 2000px; /* 远大于可能的内容高度，确保完全展开 */
    height: auto; /* 由内容决定实际高度 */
           background-color: #fff; /* 背景色 */;
    a {
    border-bottom: 1px solid #a5a2a2;
    }
  }

  /* 菜单项间距优化 */
  .nav-item {
    margin-bottom: 10px;
    border-bottom: 1px solid #f5f5f5;
  }

  .nav-link {
    padding: 12px 0;
    display: block;
  }

  .dropdown-item {
    padding: 10px 0;
    width: 100%;
    display: block;
  }
}
@media screen and (max-width: 750px) {
  /* 固定导航栏在顶部 */
  .nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1050;
    height: 60px; /* 固定导航栏高度，确保菜单定位准确 */
    background-color: white; /* 避免导航栏透明导致内容穿透 */
  }
  
  /* 为页面内容添加顶部间距，避免被固定导航栏遮挡 */
  .body > .el-config-provider {
    margin-top: 60px; /* 与导航栏高度一致 */
  }
  
  /* 汉堡按钮和logo固定样式 */
  .navbar-brand {
    position: relative;
    z-index: 1051;
    height: 60px;
    display: flex;
    align-items: center; /* 垂直居中logo */
  }
  
  .mobile-actions {
    position: relative;
    z-index: 1051;
    height: 60px;
    display: flex;
    align-items: center; /* 垂直居中按钮 */
  }
  
  /* 手风琴式菜单样式 - 高度随内容自然延伸 */
  .navbar-collapse {
    position: fixed;
    top: 60px; /* 与导航栏高度一致 */
    left: 0;
    right: 0;
    /* 移除固定底部，改为高度自适应 */
    height: auto; /* 高度由内容决定 */
    max-height: calc(100vh - 60px); /* 最大高度不超过屏幕剩余空间 */
    background-color: white;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    z-index: 1050;
    overflow-y: auto; /* 内容超出最大高度时可滚动 */
    padding: 20px;
  }
  
  /* 菜单展开状态 */
  .navbar-collapse.show {
    transform: translateX(0);
    background-color: #fff;
  }
  
  /* 手风琴子菜单样式 - 高度随内容延伸 */
  .dropdown-menu {
    position: static;
    width: 100%;
    border: none;
    box-shadow: none;
    padding-left: 20px;
    max-height: 0; /* 初始折叠状态 */
    overflow: hidden;
    transition: max-height 0.3s ease;
    height: auto; /* 子菜单高度由内容决定 */
  }
  
  .dropdown.show .dropdown-menu {
    max-height: 2000px; /* 足够大的值确保内容完全显示 */
    text-align: center;
           background-color: #fff
  }
  
  .dropdown.show .dropdown-menu a {
    border-bottom: 1px solid #a5a2a2;
    display: block; /* 让链接占满整行，提升点击体验 */
    padding: 8px 0;
  }
  
  /* 菜单项样式优化 */
  .navbar-nav .nav-item {
    margin-bottom: 10px;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 10px;
  }
  
  .navbar-nav .nav-item:last-child {
    border-bottom: none;
  }
  
  /* 导航链接样式调整，确保内容撑开高度 */
  .nav-link {
    display: block;
    padding: 10px 0; /* 增加内边距，让菜单项更易点击 */
  }
}
@media screen and (max-width: 750px) {
  // .body {
  //   min-width: 375px !important;
  // }
  .foot {
    display: none;
  }
  .contain {
    width: 100% !important;  }
  .nav {
    // min-width: 375px;
    justify-content: space-between;
  }
  .navbar {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 2px;
    // width: 100%;
}
  .mobile-actions {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-left: auto;
  }
  
  /* 白色汉堡菜单图标 */
 .navbar-toggler.icon-white.navbar-toggler-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
  }
  
  /* 确保移动端导航按钮显示为白色 */
 .navbar-toggler {
    border-color: rgb(255, 255, 255) ;
  }
  
  /* 调整移动端语言选择框位置 */
 .actionch {
  margin-right: -20px;
  }
  .menu_list {
    // overflow-x: scroll;
    white-space: nowrap;
    justify-content: flex-start !important;

    width: 100%;
    .menu_item {
      font-size: 10px !important;
      flex-shrink: 0;
      width: 50px !important;
    }
  }
  //   ::-webkit-scrollbar {
  //   /* 隐藏滚动条 */
  //   display: none;
  // }
}
// 375
@media screen and (max-width: 375px) {
 .contain {
  max-width: 375px !important;
 }
}
</style>
